import { CallEmsApi, iEmsApiResponse, iEmsApiResponseBody } from "../Logic/TenantAPI";

export interface GetMailboxResponse {
    items: DerpartmentList[];
}

export interface DerpartmentList {
    id: number;
    name: string;
}

export interface MailboxMember {
    userID: number;
    roleID: number;
}

export interface MailboxMemberResponse {
    items: MailboxMember[];
}

export interface MailboxMembers {
    mailboxID: number;
    members: MailboxMember[];
}

export async function GetMailboxes(tenantToken: string): Promise<iEmsApiResponseBody<GetMailboxResponse>> {
    return await CallEmsApi<GetMailboxResponse>(tenantToken, "GET", "Mailboxes");
}

// Membershp //

export async function GetMembership(
    tenantToken: string,
    id: number
): Promise<iEmsApiResponseBody<MailboxMemberResponse>> {
    return await CallEmsApi<MailboxMemberResponse>(tenantToken, "GET", `Mailboxes/${id}/Members`);
}

export async function UpdateDepartment(
    tenantToken: string,
    id: number,
    request: { name: string }
): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "PUT", `Departments/${id}`, request);
}

export async function DeleteDepartment(tenantToken: string, id: number): Promise<iEmsApiResponseBody<iEmsApiResponse>> {
    return await CallEmsApi<any>(tenantToken, "DELETE", `Departments/${id}`);
}

export async function CreateDepartment(tenantToken: string, request: { name: string }): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "POST", `Departments`, request);
}
